import $ from 'jquery';

var classPrefix = 'profile__level--lte-';
var lvList = [9, 19, 29, 39, 49, 59, 69, 79, 89, 99, 1000];

export default function () {
  var $lv = $('.profile__level');

  if ($lv.length < 1) {
    return;
  }

  var lvNum = parseInt($lv.text().split('.').pop(), 10) || 0;
  var targetClassLv;

  $.each(lvList.reverse(), function (i, level) {
    if (lvNum <= level) {
      targetClassLv = level;
    }
  });

  $lv.addClass(classPrefix + targetClassLv.toString());
}
